import { LargeText, SmallText } from "../../../dashboard/styles";
import { SearchBar } from "../../../contractorDashboard/detailScreens/SearchBar";
import React, { useEffect, useMemo, useState } from "react"; // @ts-ignore
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FunctionalButton } from "../../../../components/functionalButton";
import {
  Col,
  Row,
  SelectedUnderwritersContainer,
  Table,
  UnderwriterListItem,
} from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import { Dialog } from "@material-ui/core";
import { StyledPaper } from "components/addProjectRemarkPopup/styles";
import {
  CloseButton,
  SmallTitleText,
} from "../../../underwriterDashboard/idpDocuments/styles";
import PledgxLogo from "../../../../assets/common/pledgxLogo";
import { FormTitle } from "../../../homePage/styles";
import { StyledInput } from "../styles";
import { StyledLabel } from "../../../../components/pickList/styles";
import { underwriteeListForAgentSelector } from "data/selectors/underwriters";
import {
  getUnderwriterListForAgent,
  inviteUnderwriters,
} from "data/actions/underwriters";
import Spinner from "components/spinner";
import { checkUnderwriterUserAvailable } from "../../../../api/esub";
import { UnderwritersNotAvailablePopup } from "./UnderwritersNotAvailablePopup";
import { SuccessPopup } from "./SuccessPopup";
import { ESubInfo } from "../bondDetails/types";
import { Underwriter } from "./types";
import { AlertPopup } from "../../../../components/alertPopup/alertPopup";
import { BackButton } from "components/backButton";
import { BackButtonContainer } from "pages/underwriterDashboard/idpDocuments/labelEditor/styles";

type InviteUnderwriterProps = {
  esubData: ESubInfo;
};

export const InviteUnderwriters = ({ esubData }: InviteUnderwriterProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const underwriteeListForAgentData = useSelector(
    underwriteeListForAgentSelector,
  );

  const [query, setQuery] = useState("");
  const [selectedUnderwriters, setSelectedUnderwriters] = useState<
    Underwriter[]
  >([]);
  const [allUnderwriters, setAllUnderwriters] = useState<Underwriter[]>([]);
  const [openAddUnderwriterPopup, setOpenAddUnderwriterPopup] = useState(false);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);

  useEffect(() => {
    if (!underwriteeListForAgentData?.length) {
      dispatch(getUnderwriterListForAgent());
    }
  }, [dispatch]);

  useEffect(() => {
    if (underwriteeListForAgentData?.length) {
      setAllUnderwriters(underwriteeListForAgentData);
    }
  }, [underwriteeListForAgentData]);

  // filtered underwriters are the derived from "allUnderwriters" state filtered by search query
  const filteredUnderwriters = useMemo(() => {
    if (!query) return allUnderwriters;
    const lower = query.toLowerCase();
    return allUnderwriters.filter((u) =>
      Object.values(u).some((val) =>
        val?.toString().toLowerCase().includes(lower),
      ),
    );
  }, [allUnderwriters, query]);

  const handleInvite = () => {
    dispatch(
      inviteUnderwriters(
        {
          esubId: esubData?.esubId ?? "",
          underwriters: selectedUnderwriters,
        },
        () => {
          setOpenSuccessPopup(true);
        },
        () => { },
      ),
    );
  };

  const handleBack = () => {
    history.push("/prequalify/preview/ecqs");
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", width: "860px" }}>
        <BackButtonContainer>
          <BackButton handleClick={handleBack} buttonText="Back to eSUB" margin={0} />
        </BackButtonContainer>
        <LargeText style={{ margin: "40px 0" }}>
          Select the Underwriters you want to invite to quote
        </LargeText>
        <SelectedUnderwriters
          selectedUnderwriters={selectedUnderwriters}
          setSelectedUnderwriters={setSelectedUnderwriters}
          allUnderwriters={allUnderwriters}
          setAllUnderwriters={setAllUnderwriters}
        />
        <div style={{ display: "flex", margin: "20px 0" }}>
          <SearchBar
            filterApi={null}
            setFilteredData={null}
            searchWidth="600px"
            filteredData={null}
            setInternalSearchResults={() => { }}
            query={query}
            setQuery={setQuery}
            internalSearch={true}
            searchPlaceHolder="Search underwriters"
            marginRight="10px"
          />
          <FunctionalButton
            isReversedColor={true}
            handleButton={() => setOpenAddUnderwriterPopup(true)}
            buttonTitle="Add New Underwriter"
            width="100%"
            height={undefined}
            marginRight={undefined}
            marginLeft={undefined}
            marginTop={undefined}
            marginBottom={undefined}
            fontSize={undefined}
            disabled={undefined}
            icon={undefined}
            hasBoxShadow={undefined}
            frontIcon={undefined}
            weight={undefined}
            borderColor={undefined}
            selected={undefined}
          />
        </div>
        <UnderwriterTable
          setAllUnderwriters={setAllUnderwriters}
          selectedUnderwriters={selectedUnderwriters}
          setSelectedUnderwriters={setSelectedUnderwriters}
          filteredUnderwriters={filteredUnderwriters}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "50px 0 20px 0",
          }}
        >
          <FunctionalButton
            handleButton={handleInvite}
            buttonTitle="Invite"
            width="200px"
            height={undefined}
            isReversedColor={undefined}
            marginRight={undefined}
            marginLeft={undefined}
            marginTop="30px"
            marginBottom={undefined}
            fontSize={undefined}
            disabled={selectedUnderwriters.length === 0}
            icon={undefined}
            hasBoxShadow={undefined}
            frontIcon={undefined}
            weight={undefined}
            borderColor={undefined}
            selected={undefined}
          />
        </div>
        <SmallText style={{ color: "#A1A1A1" }}>
          Select at least one underwriter to publish a private eSUB.
        </SmallText>
      </div>
      <SuccessPopup open={openSuccessPopup} setOpen={setOpenSuccessPopup} />
      <AddUnderwriterPopup
        open={openAddUnderwriterPopup}
        setOpen={setOpenAddUnderwriterPopup}
        setSelectedUnderwriters={setSelectedUnderwriters}
      />
      <UnderwritersNotAvailablePopup
        open={openErrorPopup}
        setOpen={setOpenErrorPopup}
      />
    </>
  );
};

type SelectedUnderwritersProps = {
  selectedUnderwriters: Underwriter[];
  setSelectedUnderwriters: any;
  allUnderwriters: Underwriter[];
  setAllUnderwriters: any;
};

// the list of selected underwriters
const SelectedUnderwriters = ({
  selectedUnderwriters,
  setSelectedUnderwriters,
  allUnderwriters,
  setAllUnderwriters,
}: SelectedUnderwritersProps) => {
  const handleRemoveSelectedUnderwriter = (underwriter: Underwriter): void => {
    setSelectedUnderwriters((underwriters: Underwriter[]) => {
      return underwriters.filter((u) => u !== underwriter);
    });
    if (!underwriter.isTemporary) {
      setAllUnderwriters([...allUnderwriters, underwriter]);
    }
  };

  return (
    <>
      <span style={{ marginBottom: "5px" }}>Selected Underwriters</span>
      {selectedUnderwriters.length > 0 ? (
        <SelectedUnderwritersContainer>
          {selectedUnderwriters.map((underwriter, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 auto",
                minWidth: "200px",
              }}
            >
              <UnderwriterListItem>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>
                    {underwriter.first_name + " " + underwriter.last_name}
                  </span>
                  <span>{underwriter.province}</span>
                </div>
                <div>
                  <CloseIcon
                    onClick={() => handleRemoveSelectedUnderwriter(underwriter)}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </UnderwriterListItem>
            </div>
          ))}
        </SelectedUnderwritersContainer>
      ) : (
        <SelectedUnderwritersEmptyState />
      )}
    </>
  );
};

// replaces SelectedUnderwriters when no underwriters are selected
const SelectedUnderwritersEmptyState = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "white",
      height: 150,
      borderRadius: "8px",
      border: "1px solid #EBE9F1",
    }}
  >
    <span style={{ color: "#A1A1A1" }}>
      Selected Underwriters will appear here.
    </span>
  </div>
);

type UnderwriterTableProps = {
  setAllUnderwriters: any;
  selectedUnderwriters: Underwriter[];
  setSelectedUnderwriters: any;
  filteredUnderwriters: Underwriter[];
};

// list of selectable underwriters, if an underwriter has been selected it is removed from this table
const UnderwriterTable = ({
  setAllUnderwriters,
  selectedUnderwriters,
  setSelectedUnderwriters,
  filteredUnderwriters,
}: UnderwriterTableProps) => {
  const handleSelectUnderwriter = (underwriter: Underwriter): void => {
    setSelectedUnderwriters([...selectedUnderwriters, underwriter]);
    setAllUnderwriters((underwriters: Underwriter[]) => {
      return underwriters.filter((u) => u !== underwriter);
    });
  };

  return (
    <>
      {filteredUnderwriters.length > 0 ? (
        <Table>
          {filteredUnderwriters.map((underwriter: Underwriter, index) => (
            <Row
              key={index}
              onClick={() => handleSelectUnderwriter(underwriter)}
            >
              <Col>{underwriter.first_name + " " + underwriter.last_name}</Col>
              <Col>{underwriter.province}</Col>
              <Col>{underwriter.email}</Col>
            </Row>
          ))}
        </Table>
      ) : (
        <p style={{ textAlign: "center" }}>No underwriters found.</p>
      )}
    </>
  );
};

type AddUnderwriterPopupProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  setSelectedUnderwriters: any;
};

// pop-up for adding new underwriters
const AddUnderwriterPopup = ({
  open,
  setOpen,
  setSelectedUnderwriters,
}: AddUnderwriterPopupProps) => {
  const [underwriter, setUnderwriter] = useState<Underwriter>({
    city: "",
    email: "",
    first_name: "",
    id: 0,
    institution: "",
    last_name: "",
    province: "",
    status: "",
    isTemporary: true,
  });

  const [openDuplicateUnderwriterPopup, setOpenDuplicateUnderwriterPopup] =
    useState(false);
  const [isValidating, setIsValidating] = useState(false);

  const handleAddTemporaryUnderwriter = () => {
    setSelectedUnderwriters((selectedUnderwriters: Underwriter[]) => [
      ...selectedUnderwriters,
      underwriter,
    ]);
    setOpen(false);
  };

  const validateForDuplicate = () => {
    checkUnderwriterUserAvailable({ email: underwriter.email })
      .then((data) => {
        if (data?.message === "User not available") {
          setOpenDuplicateUnderwriterPopup(true);
          return;
        }
        handleAddTemporaryUnderwriter();
      })
      .catch((err) => {
        console.error("error", err);
      });
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        TransitionComponent={React.Fragment}
      >
        <StyledPaper elevation={0}>
          <CloseButton
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon />
          </CloseButton>
          <PledgxLogo width={undefined} height={undefined} />
          <FormTitle style={{ marginTop: "10px" }}>
            Add New Underwriter
          </FormTitle>
          <div
            style={{
              margin: "30px 0",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <StyledLabel>Name</StyledLabel>
              <StyledInput
                style={{ width: "300px" }}
                value={underwriter.first_name}
                onChange={(e) => {
                  setUnderwriter((underwriter) => ({
                    ...underwriter,
                    first_name: e.target.value,
                  }));
                }}
              />
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <StyledLabel>Email</StyledLabel>
              <StyledInput
                style={{ width: "300px" }}
                onChange={(e) => {
                  setUnderwriter((underwriter) => ({
                    ...underwriter,
                    email: e.target.value,
                  }));
                }}
              />
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <StyledLabel>Province</StyledLabel>
              <StyledInput
                style={{ width: "300px" }}
                onChange={(e) => {
                  setUnderwriter((underwriter) => ({
                    ...underwriter,
                    province: e.target.value,
                  }));
                }}
              />
            </div>

            <div
              style={{
                marginTop: "40px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {!isValidating ? (
                <FunctionalButton
                  buttonTitle="Submit"
                  handleButton={validateForDuplicate}
                  width="200px"
                  height={undefined}
                  isReversedColor={undefined}
                  marginRight={undefined}
                  marginLeft={undefined}
                  marginTop={undefined}
                  marginBottom={undefined}
                  fontSize={undefined}
                  disabled={!underwriter.first_name || !underwriter.email}
                  icon={undefined}
                  hasBoxShadow={undefined}
                  frontIcon={undefined}
                  weight={undefined}
                  borderColor={undefined}
                  selected={undefined}
                />
              ) : (
                <div
                  style={{
                    gap: "15px 0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Spinner color={undefined} size={undefined} />
                  <SmallTitleText>
                    Checking underwriter availability
                  </SmallTitleText>
                </div>
              )}
            </div>
          </div>
        </StyledPaper>
      </Dialog>
      <AlertPopup
        bodyContent={undefined}
        headerText={"Duplicate Underwriter"}
        subHeaderText={"An underwriter with that email already exists."}
        openPopup={openDuplicateUnderwriterPopup}
        setOpenPopup={setOpenDuplicateUnderwriterPopup}
      />
    </>
  );
};
